// components/features/modules/ModulesList.tsx

import { Module } from '../../../types/features/Module';
import TableList, { SelectAction } from '../../ui/TableList';
import ModuleRow from './ModuleRow';

interface ModulesListProps {
  modules: Module[];
  onAction: (module: Module) => void;
  onSelectModules?: (selectedModules: Module[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function ModulesList({
  modules,
  onAction,
  onSelectModules,
  selectable = false,
  selectActions
}: ModulesListProps) {
  const columns = [
    { header: "Module", className: "w-2/5" },
    { header: "Clé", className: "hidden sm:table-cell w-1/6" },
    { header: "Statut", className: "hidden md:table-cell w-1/6" },
    { header: "Créé le", className: "hidden xl:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={modules}
      columns={columns}
      getId={(module) => module.id}
      onAction={onAction}
      onSelectItems={onSelectModules}
      selectable={selectable}
      emptyMessage="Aucun module trouvé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(module, isSelected, onSelect) => (
        <ModuleRow
          key={module.id}
          module={module}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}